const REFERRER_STORAGE_KEY = 'referrer';
const DIRECT_REFERRER = 'direct';

function isExternalReferrer(referrer) {
  if (!referrer) {
    return false;
  }

  try {
    const referrerUrl = new URL(referrer);
    return referrerUrl.hostname !== window.location.hostname;
  } catch {
    return false;
  }
}

function getStoredReferrer() {
  return window.localStorage.getItem(REFERRER_STORAGE_KEY);
}

function setStoredReferrer(referrer) {
  window.localStorage.setItem(REFERRER_STORAGE_KEY, referrer);
}

export function initializeReferrerAttribution() {
  const currentReferrer = document.referrer || '';
  const storedReferrer = getStoredReferrer();

  if (isExternalReferrer(currentReferrer)) {
    setStoredReferrer(currentReferrer);
    return currentReferrer;
  }

  if (isExternalReferrer(storedReferrer)) {
    return storedReferrer;
  }

  // Remove stale same-host referrers written by the previous attribution implementation.
  setStoredReferrer(DIRECT_REFERRER);
  return DIRECT_REFERRER;
}

export function readReferrerAttribution() {
  return initializeReferrerAttribution();
}
